import {FC} from 'react'
import ProductImage from 'app/components/products/ProductImage'
import truncate from 'lodash/truncate'

type Props = {
  item: {
    variant: any
    quantity: number
    orderedQuantity: number
  }
}

const LineItem: FC<Props> = ({item}) => {
  const {quantity, orderedQuantity, variant} = item
  const {product} = variant
  return (
    <tr className='fw-bolder text-gray-700 fs-5'>
      <td className='pt-6'>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px'>
            <span className='symbol-label'>
              <ProductImage product={product} />
            </span>
          </div>
          <div className='ms-5'>
            <span className='fw-bolder text-gray-600 text-hover-primary'>
              {truncate(product.name, {length: 30})}
            </span>
            <div>
              <span className='fs-7 text-muted'>{variant.name}</span>
              <span className='fs-7 ms-5 fw-bold'>{variant.sku}</span>
            </div>
          </div>
        </div>
      </td>
      <td className='pt-6'></td>
      <td className='pt-6'></td>
      <td className='pt-6 text-dark fw-boldest text-end'>{`${quantity} of ${orderedQuantity}`}</td>
    </tr>
  )
}

export default LineItem
